export default [
  {
    name: "Name",
    id: "name",
    type: "text",
  },
  {
    name: "Role",
    id: "role",
    type: "boolean",
    params: [
      { value: "both", label: "Both (Supplier & Customer)" },
      { value: "supplier", label: "Supplier" },
      { value: "customer", label: "Customer" },
    ],
  },
];
